module.exports = __webpack_public_path__ + "static/media/Ethiopia - ET.4a3bc1a5.png";